import { SAVE_SUCCESSFULLY_MESSAGE } from 'components/Common/AlertMessages';
import {
  GET_INCIDENT_SLA_SECTION_LIST_LOADING,
  GET_INCIDENT_SLA_SECTION_LIST_SUCCESS,
  GET_INCIDENT_SLA_SECTION_LIST_FAILURE,
  SEARCH_SLA_INFORMATIONL_LIST_LOADING,
  SEARCH_SLA_INFORMATIONL_LIST_SUCCESS,
  SEARCH_SLA_INFORMATIONL_LIST_FAILURE,
  POST_SLA_RESPONSE_LOADING,
  POST_SLA_RESPONSE_SUCCESS,
  POST_SLA_RESPONSE_FAILURE,
  SET_SLA_REPONSE_ERROR_LIST,
} from '../actions/slaInformation';
import { toast } from 'react-toastify';

const initialState = {
  loading: false,
  slaInformationList: [],
  incidentSlaSectionList: [],
  slaResponseErrorList: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_SLA_INFORMATIONL_LIST_LOADING:
    case GET_INCIDENT_SLA_SECTION_LIST_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }

    case POST_SLA_RESPONSE_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }

    case SEARCH_SLA_INFORMATIONL_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        slaInformationList: payload.Data.Rows,
      };
    }

    case GET_INCIDENT_SLA_SECTION_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        incidentSlaSectionList: payload?.Data,
      };
    }

    case POST_SLA_RESPONSE_SUCCESS: {
      toast.success(SAVE_SUCCESSFULLY_MESSAGE);
      return {
        ...state,
        loading: false,
        slaResponseErrorList: payload?.Errors,
      };
    }

    case SEARCH_SLA_INFORMATIONL_LIST_FAILURE:
    case GET_INCIDENT_SLA_SECTION_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case POST_SLA_RESPONSE_FAILURE: {
      return {
        ...state,
        loading: false,
        slaResponseErrorList: payload?.Errors,
      };
    }

    case SET_SLA_REPONSE_ERROR_LIST: {
      return {
        ...state,
        slaResponseErrorList: payload,
      };
    }

    default:
      return state;
  }
}
